// kintoneシステム関連の型定義

// 開発ステップの種類
export type DevelopmentStep =
  | "app-creation"
  | "field-creation"
  | "customize-code"
  | "layout-update";

// 開発ステップ情報
export interface DevelopmentStepInfo {
  id: DevelopmentStep;
  label: string;
  order: number;
}

// 開発ステップ一覧
export const DEVELOPMENT_STEPS: DevelopmentStepInfo[] = [
  { id: "app-creation", label: "アプリの作成", order: 1 },
  { id: "field-creation", label: "フィールド作成", order: 2 },
  { id: "customize-code", label: "カスタマイズコード生成", order: 3 },
  { id: "layout-update", label: "アプリのデプロイ", order: 4 },
];

// 開発中ジョブ情報
export interface DevelopingJob {
  jobId: string;
  spaceName: string;
  subdomain: string;
  spaceId?: string | undefined;
  currentStep: DevelopmentStep;
  startedAt: string; // ISO文字列
  createdBy: {
    id: string;
    name: string;
  };
  statusMessage?: string | undefined;
}
